
export default {
    name: 'historique-examen-fe',
    components: {},
    props: {
        historique: Object
    },
    data() {
        return {

        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {

    }
}